import axios from "./axiosInstance";

const cmsPagesAPI = {
  store: (payload) => axios.post("/cmspages/", payload),
  details: (slug) => axios.get(`/cmspages/${slug}`),
};

export default cmsPagesAPI;
